import penUnderlineIcon from './svg/penUnderlineIcon.svg?url';

export const PenUnderlineIcon = () => {
	return <img src={penUnderlineIcon} alt="Edit icon" />;
};
